module.exports = __webpack_public_path__ + "media/images/course/depo_04-43855ecc65fc76b13e00610ba36afd94.png";